import React from "react";
import { Document, Page, pdfjs } from "react-pdf";
import pdf_file from '../../../../Global/assets/Digestive Glands.pdf'


pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;
const Dglands = () => {
    return (
        <>
            <div id="ExperimentsB" style={{height:'100vh'}}>
                <Document file={pdf_file} >
                    <Page pageNumber={1} />
                </Document>
            </div>
        </>
    )
}

export { Dglands }